import Clarity from '@microsoft/clarity';

import configManager from 'features/app/config/configManager';

export function initializeClarity(): void {
	const projectId = configManager.getConfig().clarityProjectId;
	if (!projectId) {
		return;
	}

	Clarity.init(projectId);
}
